import { GuiDetailGeneric } from "../../GuiDetailGeneric";
import { Chart, ChartConfiguration } from "../../chart-setup";
import { IChartData } from "../../Interface/IChartData";

export class GuiDetailSupportKpi extends GuiDetailGeneric {
    constructor() {
        super("Kpi");
        // Charts der KPI-Detailseite (24-Monats-Zeitreihe). DOM ist beim Dispatch (DOM-ready) da.
        this.drawChart("chartKpiAktionen", "jsonChartKpiAktionen", [
            { label: "Aktionen", color: "#044135" }
        ]);
        this.drawChart("chartKpiBenutzer", "jsonChartKpiBenutzer", [
            { label: "Anfallstelle", color: "#044135" },
            { label: "Abfallbeauftragter", color: "#0CAD8E" }
        ]);
    }

    // Zeichnet einen Linien-Chart. series[0] -> values, series[1] -> values2 (zweite Reihe).
    private drawChart(canvasId: string, inputId: string, series: { label: string; color: string }[]) {
        const ctx = document.getElementById(canvasId) as HTMLCanvasElement | null;
        const input = document.getElementById(inputId) as HTMLInputElement | null;
        if (ctx == null || input == null) {
            return;
        }
        const json = input.value;
        if (json == undefined || json === "null" || json === "") {
            return;
        }

        const chartData = JSON.parse(json) as IChartData;
        const reihen = [chartData.values, chartData.values2];

        const config: ChartConfiguration = {
            type: "line",
            data: {
                labels: chartData.labels,
                datasets: series.map((s, i) => ({
                    label: s.label,
                    data: reihen[i] ?? [],
                    backgroundColor: s.color,
                    borderColor: s.color,
                    tension: 0.2
                }))
            },
            options: {
                responsive: true,
                // Hoehe an die Spaltenbreite koppeln (Breite : Hoehe), damit die Charts nicht hoch werden.
                maintainAspectRatio: true,
                aspectRatio: 2.5,
                plugins: {
                    legend: { display: true, position: "top" }
                }
            }
        };

        new Chart(ctx, config);
    }
}
